import * as React from 'react';
import noop from 'lodash/noop';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import DeliverableCustomContext from '../context/DeliverableCustomContext';

import './deliverable-custom-trigger-footer.scss';

const DeliverableCustomTriggerFooter = (
  item
): React.ReactNode => {
  const context = React.useContext(DeliverableCustomContext);

  const handleSelectionChange = (event: React.MouseEvent): void => {
    const callback = context?.onSelectionChange || noop;

    callback(!item.isSelected, item, event);
  };

  return (
    <div
      className="deliverable-custom-trigger-footer"
      onClick={handleSelectionChange}
    >
      <InputCheckbox
        key={`deliverable-custom-trigger-footer__checkbox--${item.id}`}
        id={`deliverable-custom-trigger-footer__checkbox--${item.id}`}
        name="deliverable-custom-trigger-footer__checkbox"
        value={String(!!item.isSelected)}
        checked={!!item.isSelected}
        labelClass="deliverable-custom-trigger-footer__label"
      />
    </div>
  );
};

export default DeliverableCustomTriggerFooter;
